import { useMemo, useState, useEffect} from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useGetRecentChatsQuery } from "../../services/chatService";
import React from "react";
import ChatThreadListing from "./chatThreadListing";

export default function PatientChatThread(){

    const groupChatContext = useGroupChatContext();
    const {selectedLocations, chatFilter, selectedChatTab} = useMemo(() => ({
        selectedLocations: groupChatContext.selectedLocations,
        chatFilter: groupChatContext.chatFilter,
        selectedChatTab: groupChatContext.selectedChatTab
    }));

    const [pagination, setPagination] = useState({limit: 10, page: 1});
    const [chatApiParams, setChatApiParams] = useState({ location_id: selectedLocations, ...pagination, last_chat_id: '', unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only, unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention });

    const {
        data: patientChats, isFetching
    } = useGetRecentChatsQuery({...chatApiParams}, {refetchOnMountOrArgChange: true });


    useEffect(()=>{
        let chatThreadsLength = patientChats?.data?.length;
        let lastChat = {}
        if(chatThreadsLength){
            lastChat = patientChats?.data[chatThreadsLength-1];
        }
        setChatApiParams({location_id: selectedLocations, ...pagination, last_chat_id: pagination.page == 1 ? '' : lastChat.chat_id, unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only, unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention})
    }, [pagination])

    useEffect(()=>{
        setPagination({...pagination, page: 1});
    }, [selectedLocations, chatFilter, selectedChatTab])


    const fetchMoreChats = () => {
        setPagination({...pagination, page: ++pagination.page})
    }

    return(
        <div>
            <ChatThreadListing chatThreadsData={patientChats} fetchMoreChats={fetchMoreChats} isLoadingData={isFetching} pagination={pagination} />
        </div>
    )
}